import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { closeContactMethod } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';

import styles, {
  ColCard,
  gridStyle,
  Row,
  RowInner,
  useError,
  validatePhoneNo,
} from 'utils/formStyles';
import { getService } from '../reducers/service';

import Dictionary from 'components/Dictionary';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';

import TextField2 from 'components/TextField2';
import { validateEmail } from 'utils/functions';
import { notify } from 'reducers/NotifierReducer';
import Checkbox2 from 'components/Checkbox2';

const useStyles = makeStyles((theme) => ({
  ...styles,
  fileInfo: {
    minHeight: 35,
    marginBottom: 16,
    '& img': {
      maxHeight: 24,
      borderRadius: 3,
      marginRight: 8,
    },
  },
  item: gridStyle(300, 500),
  txtField: {
    minWidth: 350,
  },
}));

function ContactMethodDialog(props) {
  const classes = useStyles();
  const { data, PartyType } = props;
  // console.log('data', data);
  const dispatch = useDispatch();
  const [ContactMethod, setContactMethod] = useState('');
  const [MethodType, setMethodType] = useState('Phone');
  const [Info, setInfo] = useState('');
  const [IsDefault, setIsDefault] = useState('');
  const [Notes, setNotes] = useState('');
  const [errors, setErrors] = useState();
  const { err, delErr, isValidAndChanged, formChanged } = useError(errors, setErrors);
  const user = useSelector((state) => state.user);
  // console.log('user', user.userData.user.Username);
  useEffect(() => {
    if (data.ptsInfoID) {
      const { ptsInfoID, ptsParentID, Notes, ContactMethod, MethodType, Info } = data;
      setContactMethod(ContactMethod);
      setMethodType(MethodType);
      setInfo(Info);
      setNotes(Notes);
    }

    // eslint-disable-next-line
  }, []);

  const close = () => {
    dispatch(closeContactMethod());
  };

  const save = async () => {
    try {
      const username = user.userData.user.Username;
      let formData = {
        PartyType: data.PartyType,
        ContactMethod: ContactMethod.Code || '',
        MethodType: MethodType.Code || '',
        IsDefault: IsDefault || false,
        Info: Info || '',
        Notes: Notes || '',
      };
      // console.log('formData', formData);
      props.showSpinner();
      const service = getService('record-person-contact');
      if (data.ptsParentID && data.ptsInfoID) {
        const res = await service.patch(data.ptsInfoID, { ...formData, UpdatedBy: username });
        // console.log('edit res', res);
        dispatch(notify('Contact updated', 'success'));
      } else {
        const res = await service.create({
          ...formData,
          ptsParentID: data.ptsParentID,
          CreatedBy: username,
        });
        console.log('add res', res);

        dispatch(notify('Contact Created', 'success'));
      }
    } catch (err) {
      props.handleError(err);
    } finally {
      close();
      props.hideSpinner();
    }
  };

  const renderActions = () => {
    return (
      <>
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          disabled={!isValidAndChanged()}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const renderContactMethod = () => {
    const onChange = (ev, val) => {
      setContactMethod(val);
      // setInfo('');
      formChanged();
      delErr('Info');
      if (!val) setMethodType(null);
    };
    return (
      <Dictionary
        className={classes.item}
        options="ContactMethods"
        onChange={onChange}
        value={ContactMethod}
        label="Contact Method"
      />
    );
  };

  // const renderPartyType = () => {
  //   const onChange = (ev, val) => {
  //     setPartyType(val);
  //     formChanged();
  //   };
  //   return (
  //     <Dictionary
  //       className={classes.item}
  //       options="PartyTypes"
  //       onChange={onChange}
  //       value={PartyType}
  //       label="Party Type"
  //     />
  //   );
  // };
  const renderMethodType = () => {
    const onChange = (ev, val) => {
      setMethodType(val);
      formChanged();
    };
    const errors = err(!ContactMethod || (ContactMethod && MethodType), 'ContactMethodType');
    return (
      <Dictionary
        className={classes.item}
        options="ContactMethodTypes"
        onChange={onChange}
        value={MethodType}
        label="Contact Type"
        error={errors}
        disabled={!ContactMethod}
      />
    );
  };

  const renderInfo = () => {
    const onChange = (ev, val) => {
      setInfo(val);
      formChanged();
    };
    const type = ContactMethod?.Code;
    let error;
    if (type === 'Phone') {
      error = err(validatePhoneNo(Info), 'Info', 'Invalid phone number');
    }
    if (type === 'Email') {
      error = err(validateEmail(Info), 'Info', 'Invalid email address');
    }

    return (
      <TextField2
        className={classes.item}
        label="Info"
        value={Info}
        onChange={onChange}
        max={100}
        error={error}
        type={type}
        disabled={!ContactMethod}
      />
    );
  };

  const renderIsDefault = () => {
    const onChange = (ev, val) => {
      setIsDefault(val);
      formChanged();
    };
    return (
      <div>
        <Checkbox2 checked={IsDefault} onChange={onChange} label="Is Default" />
      </div>
    );
  };

  const renderNotes = () => {
    const onChange = (ev, val) => setNotes(val);
    return (
      <TextField2
        className={classes.w100pr}
        label="Notes"
        value={Notes}
        onChange={onChange}
        max={5000}
        rows={3}
        multiline
      />
    );
  };

  return (
    <Dialog toolbar onClose={close} title="Edit Contacts" actions={renderActions()}>
      <Row>
        <ColCard minWidth={500}>
          <RowInner>
            {renderContactMethod()}
            {renderMethodType()}
          </RowInner>
          <RowInner>
            {renderIsDefault()}
            {renderInfo()}
          </RowInner>
          <RowInner>{renderNotes()}</RowInner>
        </ColCard>
      </Row>
    </Dialog>
  );
}

export default connect(null, {
  showSpinner,
  hideSpinner,
  handleError,
  notifyDataUpdate,
})(ContactMethodDialog);
